module.exports = __webpack_public_path__ + "static/media/remove-icon.27e26a46.svg";